export default function ({ store, redirect, route }) {
  const userLoggedIn = store.state.auth.loggedIn

  if (route.name.includes('login') && userLoggedIn) {
    redirect('/')
  }
}
